import { render, staticRenderFns } from "./show-point.vue?vue&type=template&id=160aa6b2&scoped=true"
import script from "./show-point.vue?vue&type=script&lang=js"
export * from "./show-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160aa6b2",
  null
  
)

export default component.exports